import * as React from 'react';
import { cn } from '@/lib/utils';

const ClassroomSidebar = React.forwardRef(({ className, ...props }, ref) => (
  <aside
    ref={ref}
    className={cn('c-classroom-sidebar', 'relative w-full flex-shrink-0', className)}
    {...props}
  />
));
ClassroomSidebar.displayName = 'ClassroomSidebar';

export { ClassroomSidebar };
